import React from 'react'

import { Box } from 'components/UI/Box/Box'
import { H5, H6 } from 'components/UI/Typography/Typography.new'

import styles from './B2BStep.module.css'

type Props = {
  step: number
  description: string
  color?: string
}

const B2BStep = ({ step, description, color }: Props): JSX.Element => {
  return (
    <div className={styles.stepContainer}>
      <Box className={styles.customBox}>
        <div className={styles.stepContent}>
          <div
            className={styles.stepNumberContainer}
            style={{ backgroundColor: color }}
          >
            <div className={styles.stepNumber}>
              <H5>{step}</H5>
            </div>
          </div>
          <H6>{description}</H6>
        </div>
      </Box>
    </div>
  )
}

export default B2BStep
